<template>
  <v-app>
    <v-toolbar class="elevation-1">
      <h4>Sign In - {{ titleCase(signin.holder_type) }}</h4>
      <v-spacer></v-spacer>
      <v-btn-toggle
        fluid
        v-model="signin.holder_type"
        class="d-flex elevation-0"
      >
        <v-btn
          v-for="type in userTypes"
          :key="type"
          :value="type.toLowerCase()"
          class="elevation-0"
          color="#E0E0E0"
          @click="clearSearch"
          >{{ type }}</v-btn
        >
      </v-btn-toggle>
    </v-toolbar>
    <v-container fluid fill>
      <v-layout>
        <v-layout white class="elevation-1 pa-4" column>
          <search-fields
            ref="searchfields"
            @firstname="firstname = arguments[0]"
            @lastname="lastname = arguments[0]"
            @clear="clearSearch"
          />
          <contact-list
            v-if="!procceed && searchList.length > 0"
            @onAction="signProceed"
            :headers="headers"
            :list="searchList"
          />
          <contact-info v-if="info._id" :item="info" />
          <track-options
            v-model="signin.option"
            :contact="info"
            :holderType="signin.holder_type"
            type="signin"
          />
          <v-flex style="text-align: right;">
            <v-btn color="success" @click="submitSignIn">Sign In</v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import Tracking from "./Tracking";
import ContactList from "./ContactList";
import ContactInfo from "./ContactInfo";
import SearchFields from "./SearchFields";
import TrackOptions from "./TrackOptions";
export default {
  extends: Tracking,
  components: { ContactList, SearchFields, ContactInfo, TrackOptions },
  data() {
    return {
      options: {
        penColor: "#c0f"
      }
    };
  },
  watch: {},
  methods: {}
};
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>
